import { IoMdCloseCircleOutline } from '@react-icons/all-files/io/IoMdCloseCircleOutline'
import React from 'react'

import type { FilterConfig, FilterState } from 'types/filter-page'

import { Button, DropdownMenu, IconButton, Text } from 'components/ds'

import { getFilterBadgeLabel } from '../utils'

type Props = Omit<React.ComponentProps<typeof Button>, 'children'> & {
  filterState: FilterState
  filterDefinition: FilterConfig
  onDelete?: React.MouseEventHandler<HTMLButtonElement>
}

// Shared with the overflow row's measuring copy so both always render the same width
const FilterBadgeTrigger = ({
  filterState,
  filterDefinition,
  onDelete,
  ...buttonProps
}: Props): React.ReactNode => {
  const filterIsActive =
    filterState.value !== undefined && filterState.operator !== undefined

  return (
    // Filter badge remains uniform in size to follow design
    <Button
      variant={filterIsActive ? 'soft' : 'surface'}
      color={filterIsActive ? undefined : 'gray'}
      highContrast={filterIsActive}
      {...buttonProps}
    >
      <Text as="span" size={{ initial: '1', sm: '2' }}>
        {getFilterBadgeLabel(filterDefinition, filterState)}
      </Text>
      {filterState.definition.fixed ? (
        <DropdownMenu.TriggerIcon />
      ) : (
        <IconButton
          size="2"
          variant="ghost"
          onClick={onDelete}
          highContrast={filterIsActive}
        >
          <IoMdCloseCircleOutline size={16} />
        </IconButton>
      )}
    </Button>
  )
}

export default FilterBadgeTrigger
